import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {Paper, Button, Typography} from "@material-ui/core";
import logo from '../../icons/img/CropSensePartners.png'
import {PeopleOutline, DashboardOutlined, SettingsOutlined, Chat, Help, LocalOfferOutlined} from '@material-ui/icons';
import {partnerService} from "../../services/PartnerService";
import {IPartnersSections} from "../../types";


interface IProps {
    selectSection(section: IPartnersSections): void
}

interface Istate {
    hover: string
}


class NavBarVertical extends React.Component<IProps, Istate> {

    state:Istate = {
        hover: ""
    }


    render() {

        return (
            <Paper
                elevation={2}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: 200,
                    height: '100%',
                    backgroundColor: "white",
                    borderRadius: 0
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 200,
                        height: 'calc(100% - 150px)',
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: 70,
                            backgroundColor: "#ECECEC"
                        }}
                    >
                        <img width= '150'
                             src= {logo}
                             alt=''
                        />
                    </div>

                    <div style={{width: "100%", height: 2, backgroundColor: "#ECECEC"}}/>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            width: "100%",
                            height: 60,
                            cursor: "pointer"
                        }}
                        onMouseEnter={() => this.setState({hover: 'dashboard'})}
                        onMouseLeave={() => this.setState({hover: ''})}
                        onClick={() => this.props.selectSection("dashboard")}
                    >

                        <DashboardOutlined
                            style={{
                                marginLeft: 20,
                                height: this.state.hover === "dashboard"? 25 : 20,
                                width: this.state.hover === "dashboard"? 25 : 20
                            }}
                        />

                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                marginLeft: 10,
                                fontSize: 18,
                                fontWeight: this.state.hover === "dashboard"? "bold" : "normal"
                        }}
                        >
                            Dashboard
                        </Typography>

                    </div>

                    <div style={{width: "100%", height: 2, backgroundColor: "#ECECEC"}}/>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            width: "100%",
                            height: 60,
                            cursor: "pointer"
                        }}
                        onMouseEnter={() => this.setState({hover: 'clientes'})}
                        onMouseLeave={() => this.setState({hover: ''})}
                        onClick={() => {
                            this.props.selectSection("clientes")
                        }}
                    >

                        <PeopleOutline
                            style={{
                                marginLeft: 20,
                                height: this.state.hover === "clientes"? 25 : 20,
                                width: this.state.hover === "clientes"? 25 : 20
                            }}
                        />

                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                marginLeft: 10,
                                fontSize: 18,
                                fontWeight: this.state.hover === "clientes"? "bold" : "normal"
                            }}
                        >
                            Clientes
                        </Typography>

                    </div>

                    {partnerService.getUser() === "utw" &&
                        <div style={{width: "100%", height: 2, backgroundColor: "#ECECEC"}}/>
                    }

                    {partnerService.getUser() === "utw" &&
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                width: "100%",
                                height: 60,
                                cursor: "pointer"
                            }}
                            onMouseEnter={() => this.setState({hover: 'promociones'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => this.props.selectSection("promociones")}
                        >

                            <LocalOfferOutlined
                                style={{
                                    marginLeft: 20,
                                    height: this.state.hover === "promociones" ? 25 : 20,
                                    width: this.state.hover === "promociones" ? 25 : 20
                                }}
                            />

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginLeft: 10,
                                    fontSize: 18,
                                    fontWeight: this.state.hover === "promociones" ? "bold" : "normal"
                                }}
                            >
                                Promociones
                            </Typography>

                        </div>
                    }


                    <div style={{width: "100%", height: 2, backgroundColor: "#ECECEC"}}/>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            width: "100%",
                            height: 60,
                            cursor: "pointer"
                        }}
                        onMouseEnter={() => this.setState({hover: 'opciones'})}
                        onMouseLeave={() => this.setState({hover: ''})}
                        onClick={() => this.props.selectSection("opciones")}
                    >

                        <SettingsOutlined
                            style={{
                                marginLeft: 20,
                                height: this.state.hover === "opciones"? 25 : 20,
                                width: this.state.hover === "opciones"? 25 : 20
                            }}
                        />

                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                marginLeft: 10,
                                fontSize: 18,
                                fontWeight: this.state.hover === "opciones"? "bold" : "normal"
                            }}
                        >
                            Opciones
                        </Typography>

                    </div>

                    <div style={{width: "100%", height: 2, backgroundColor: "#ECECEC"}}/>

                    <div
                        style={{
                            marginLeft: 10
                        }}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: 16,
                                marginTop: 5,
                                color: "#888"
                            }}
                        >
                            Support
                        </Typography>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                width: "100%",
                                height: 50,
                                cursor: "pointer"
                            }}
                            onMouseEnter={() => this.setState({hover: 'chat'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => this.props.selectSection("chat")}
                        >

                            <Chat
                                style={{
                                    marginLeft: 20,
                                    height: this.state.hover === "chat"? 20 : 15,
                                    width: this.state.hover === "chat"? 20 : 15
                                }}
                            />

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginLeft: 10,
                                    fontSize: 16,
                                    fontWeight: this.state.hover === "chat"? "bold" : "normal"
                                }}
                            >
                                Chat
                            </Typography>

                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                width: "100%",
                                height: 50,
                                cursor: "pointer"
                            }}
                            onMouseEnter={() => this.setState({hover: 'faq'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => this.props.selectSection("faq")}
                        >

                            <Help
                                style={{
                                    marginLeft: 20,
                                    height: this.state.hover === "faq"? 20 : 15,
                                    width: this.state.hover === "faq"? 20 : 15
                                }}
                            />

                            <Typography
                                style={{
                                    fontFamily: "Poppins",
                                    marginLeft: 10,
                                    fontSize: 16,
                                    fontWeight: this.state.hover === "faq"? "bold" : "normal"
                                }}
                            >
                                FAQ
                            </Typography>

                        </div>

                    </div>

                    <div style={{width: "100%", height: 2, backgroundColor: "#ECECEC"}}/>

                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 200,
                        height: 150,
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <div
                        style={{
                            width: 160,
                            borderRadius: 10,
                            borderStyle: "solid",
                            borderBlockColor: "black",
                            borderWidth: this.state.hover === "salir"? 2 : 1,
                            cursor: "pointer"
                        }}
                        onMouseEnter={() => this.setState({hover: 'salir'})}
                        onMouseLeave={() => this.setState({hover: ''})}
                        onClick={() => partnerService.logout()}
                    >
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                textAlign: "center",
                                fontSize: 18,
                                marginTop: 10,
                                marginBottom: 10,
                                fontWeight: this.state.hover === "salir"? "bold" : "normal"
                            }}
                        >
                            Salir
                        </Typography>
                    </div>
                </div>

            </Paper>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    selectSection: (section: IPartnersSections) => dispatch({type: "select-section-partners", section}),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBarVertical);
